// Game dimensions
export const GAME_WIDTH = 800;
export const GAME_HEIGHT = 600;

// Colors
export const COLORS = {
  BACKGROUND: 0x0a0a0f,
  NEON_CYAN: 0x00ffff,
  NEON_PINK: 0xff0080,
  NEON_YELLOW: 0xffff00,
  NEON_ORANGE: 0xff6b35,
  WHITE: 0xffffff,
  TOAST_BROWN: 0xd4a574,
  TRUCK_YELLOW: 0xe8d84c,
};

// Player settings
export const PLAYER = {
  SPEED: 300,
  FIRE_RATE: 500, // ms between shots
  TOAST_SPEED: 400,
  START_X: GAME_WIDTH / 2,
  START_Y: GAME_HEIGHT - 70,
  WIDTH: 80,
  HEIGHT: 64,
};

// Toast projectile settings
export const TOAST = {
  SPEED: 400,
  WIDTH: 16,
  HEIGHT: 20,
};

// Boundaries
export const BOUNDS = {
  LEFT: 40,
  RIGHT: GAME_WIDTH - 40,
  TOP: 50,
  BOTTOM: GAME_HEIGHT - 30,
};

// Game states
export const GameState = {
  BOOT: 'boot',
  HOME: 'home',
  CONFIG: 'config',
  PLAYING: 'playing',
  PAUSED: 'paused',
  GAME_OVER: 'gameover',
} as const;

export type GameState = typeof GameState[keyof typeof GameState];

